<div class="box-border-bg box-shadow box-radius left-[50%] w-[80vw] h-[85vh] top-[32vh] transform -translate-x-1/2 -translate-y-1/2 z-[60000] bg-white absolute">
    <div class="filter-call-inner-container">
        <div class="saved-filter-container">
            <div class="row">
                <div class="column col-save-btn">
                    <div class="title">
                        My Saved Filters
                    </div>
                    <div class="tinytext">
                        You can save or delete sets of filters here.
                    </div>
                </div>
                <div class="column column-del-btn">
                    <button
                    (click)="delSavedFilterSet();"
                     class="button-clear">
                        Delete
                    </button>
                </div>
            </div>

            <div *ngIf="!showNoData">
                <loader class="loader" size="small" *ngIf="showLoader"></loader>
                <table
                        [dataSource]="dataSource"
                        matSort
                        mat-table
                        class="mat-elevation-z8"
                        style="width: 100%">
                    <ng-container matColumnDef="selectedItem">
                        <th mat-header-cell *matHeaderCellDef style="width: 5%;">
                            &nbsp;
                        </th>
                        <td mat-cell *matCellDef="let element;" >
                            <input type="radio" name="selectedItem"
                                   value="{{element.filterName}}"
                                   (change)="clickRadioButton($event)"
                                   (keydown)="keyEvent($event)"
                            />
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="filterName">
                        <th mat-header-cell *matHeaderCellDef style="width: 30%;" mat-sort-header> Filter Name </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.filterName}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Region">
                        <th mat-header-cell *matHeaderCellDef style="width: 15%;" mat-sort-header> Region </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.Region}}
                        </td>
                    </ng-container>
                    <ng-container *ngIf="isCountryVisible" matColumnDef="Countries">
                        <th mat-header-cell *matHeaderCellDef style="width: 28%;" mat-sort-header> Countries </th>
                        <td mat-cell *matCellDef="let element">

                            <input
                                    type="text"
                                    class="inputBorderless"
                                    style="width: 22vw"
                                    value="{{element.Countries}}"
                                    readonly
                            />
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="lastUpdateDate">
                        <th mat-header-cell *matHeaderCellDef style="width: 10%;" mat-sort-header> Last<br/>Changed </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.lastUpdateDate.split('T')[0]}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="dateCreated">
                        <th mat-header-cell *matHeaderCellDef style="width: 10%;" mat-sort-header> Date<br/>Created </th>
                        <td mat-cell *matCellDef="let element">
                            {{element.dateCreated.split('T')[0]}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
            </div>

            <div *ngIf="!showNoData">
                <mat-paginator
                    #paginator
                    [length]="totalRows"
                    [pageIndex]="currentPage"
                    [pageSize]="7"
                    (page)="getSavedFilterSets()"
                    class="box-shadow"
                    aria-label="Select Page">
                </mat-paginator>
            </div>
            <div *ngIf="showNoData">
                <div class="show-no-data-container">
                    No filters saved yet. Please close the window and select each filter. The "Save Selections" link will appear.
                </div>
            </div>

        </div>

        <div class="save-close-container">
            <div class="close-btn-container">
                <a class="link-blue"
                (click)="clickCloseLink()">
                    Close
                </a>
            </div>
            <div class="apply-btn-container">
                <button
                class="button-blue-apply"
                id="applyButton"
                [hidden]="hideApplyButton"
                (click)="clickApplyButton()"
                >
                    Apply →
                </button>
            </div>
        </div>
    </div>

</div>
